import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import VueLoading from "vue-loading-overlay";
import i18n from "./i18n";

const app = createApp(App);

// i18n goes in before the router so route metadata can be translated on the
// very first navigation.
app.use(i18n);
app.use(router);
app.use(VueLoading);
app.mount("#app");
